module.exports = __webpack_public_path__ + "iPhone11-Black@2x.png?22e53726016df275bff7bf16513719c0";